import { orderActions } from '@store/order/orderSlice';
import { RootState } from '@store/store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function useCopyRequest(path?: 'cart' |'direct') {
  const dispatch = useDispatch();
  const itemRequest = useSelector((root: RootState) => root.item);
  const cartRequest = useSelector((root: RootState) => root.cart);
  useEffect(() => {
    if (path === 'direct') {
      dispatch(orderActions.copy(itemRequest));
    } else if (path === 'cart') {
      dispatch(orderActions.copy(cartRequest));
    }
  }, [itemRequest, cartRequest, path]);
}

export default useCopyRequest;
